import { Field } from "typegraph";

import { ID } from "common/entities/IEntity";
import { Tag } from "./Tag";

export class SubscriptionTag {

	@Field()
	public id: ID;

	@Field()
	public type: string;

	@Field({entity: Tag})
	public tag: Tag;

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/SubscriptionTag.ts